import ScheduleIcon from './ScheduleIcon';

export default ScheduleIcon;
